<div class="progress-container">
  <div class="progress-main" style="height:10px;" [style.width]="progress+'%'"></div>
</div>
